export default class TablePreferences {

    view = null;
    _columns = [];
    sort = {
        column: null,
        dir: 'asc'
    };

    constructor(data) {
        this.view = data?.view ?? this.view;
        this._columns = this.mapColumns(data.columns ?? this._columns);
        this.sort = {
            column: data?.sort?.column ?? this._columns[0]?.name ?? this.sort.column,
            dir: data?.sort?.dir ?? this.sort.dir
        };

        return this;
    }

    get columns() {
        return this._columns.map(column => column.name);
    }

    set columns(columns) {
        this._columns = this.mapColumns(columns);
    }

    mapColumns(columns) {
        return columns.map((column, k) => {
            if (typeof column === 'string') {
                // When column is a string (e.g., from Draggable reordering),
                // preserve existing column data (including width) from _columns
                const existing = this._columns.find(col => col.name === column);
                if (existing) {
                    return { ...existing, order: k };
                }
                return { name: column, order: k };
            }
            return column;
        });
    }

    getColumnWidth(name) {
        const column = this._columns.find(col => col.name === name);
        return column?.width;
    }

    setColumnWidth(name, width) {
        const column = this._columns.find(col => col.name === name);
        if (column) {
            column.width = width;
        }
    }

    toJSON() {
        let response = {...this,
            columns: this._columns
        }
        delete response._columns;
        return response;
    }
}